import {QuickAddModal} from '@/scripts/optional/quick-add';
import { TsDOM as q} from '@/scripts/core/TsDOM'
import { ProductForm } from '@/scripts/product/product-form';
import { ModelInfo } from '@/scripts/product/model-info';
import { QuickAddPopup } from '@/scripts/optional/quick-add-popup';
q.safeDefineElement(QuickAddModal);
q.safeDefineElement(ProductForm)
q.safeDefineElement(ModelInfo)
q.safeDefineElement(QuickAddPopup);
